import StepIndicator from './StepIndicator';

export default StepIndicator;
